<template lang="pug">
  .booking-info.mb-3
    b-card(v-if="hotel_groups")
      template(v-for="hotel_group in hotel_groups")
        h5 {{hotel_group.attributes.name}}
        tour-placement-combination-item(
          :combination="combination_for_group(hotel_group.id)"
          :discount="order.date_discount"
          :discount_type="order.date_discount_type"
          readonly="true"
          :currency="order.currency_name"
        )

      small.text-muted
      order-price-summary(
        :order="order"
        :penalty="order.penalty"
        :discount="order.discount"
        :date_discount="order.date_discount"
        :date_discount_type="order.date_discount_type"
        )
</template>

<script>
import PlacementInfoSite from "../tour_booking/PlacementInfoSite";
import TourPlacementCombinationItem from "../tour_booking/TourPlacementCombinationItem";
import CombinationPrice from "../tour_booking/CombinationPrice";
import OrderPriceSummary from "../shared/OrderPriceSummary";
export default {
  name: "booking_info",
  components: {OrderPriceSummary, CombinationPrice, TourPlacementCombinationItem, PlacementInfoSite},
  props: {
    order: {
      type: Object,
      default: {
        id: null,
        cost: null,
        date_discount: null,
        date_discount_type: null,
      }
    },
  },
  data(){
    return {
      booking: {}
    }
  },
  computed:{
    hotel_groups(){
      return this.$store.state.agents.hotel_groups;
    },

  },
  beforeMount() {
    this.$store.dispatch('agents/getOrderBookings', {order_id: this.order.id});
    if (this.order.currency_name !== 'RUB') {
      // обновить курс
      this.$store.dispatch('currencies/getCourse', {currency_id: this.order.currency_id});
    }
  },
  methods: {
    placements_for_group(hotel_group_id){
      return _.map(this.$store.getters['agents/hotelGroupTPPs'](hotel_group_id), (el)=>{
        const q = _.find(this.$store.state.agents.placement_price_links, (ppl)=>{return ppl.attributes.tour_placement_price_id == el.id})
        return {
          placement: el,
          quantity: q === undefined ? 0 : q.attributes.quantity,
        }
      });
    },
    combination_for_group(hotel_group_id){
      const placements = this.placements_for_group(hotel_group_id);
      return {
        placements,
        price: this.placements_price(placements)
      };
    },
    placements_price(placements){
      let price = 0;
      _.each(placements, (el)=>{
        price += el.placement.attributes.price * el.quantity;
      })
      return price;
    }
  },

}
</script>

<style scoped>

</style>